export class PateintImportHistory {
    PatientExcelHistoryId: number;
    uploadedBy: number;
    createdDate: Date;
    sheetName: string;
    uploadedByName: string;
    typeOf: string;
    addedProducts: string;
    sheetType: string;
    productStatus: string;
    locationName: string;
    totalItems: number;
    uploadedByRole: string;
}